import { withTextAlertsLoginProps } from 'viewModel/textAlertsLogin/withTextAlertsLoginProps';
import TextAlertsLogin from 'components/TextAlertsLogin/TextAlertsLogin';

export default withTextAlertsLoginProps(TextAlertsLogin);
